import { CancellationPolicy } from './cancellation-policy.model';
import { RateCharge } from './rate-charge.model';
import { RateChange } from './rate-change.model';
import { RateCharges } from './rate-charges.model';
import { RateRule } from './rate-rule.model';
import { DepositPolicy } from './deposit-policy.model';
import { AdditionalGuestRestriction } from './additional-guest-restriction.model';
export class Rate {
  code: string;
  name: string;
  desc: string;
  isRewardNight: boolean;
  cancellationPolicy: CancellationPolicy;
  serviceCharges: Array<RateCharge>;
  taxCharges: Array<RateCharge>;
  currencyCode: string;
  totalPointsCost: number;
  rateChanges: Array<RateChange>;
  originalRateChanges: Array<RateChange>;
  earlyDepartureFee: number;
  checkInTime: string;
  checkOutTime: string;
  groupCode: string;
  charges: RateCharges;
  freeNight: boolean;
  rules: Array<RateRule>;
  depositPolicy: DepositPolicy;
  refundable: boolean;
  memberExclusive: boolean;
  additionalGuestRestriction: AdditionalGuestRestriction;
  vatIsExcluded: boolean;
  constructor(code?: string) {
    this.code = code;
    this.cancellationPolicy = new CancellationPolicy(null, []);
    this.serviceCharges = new Array<RateCharge>();
    this.taxCharges = new Array<RateCharge>();
    this.rateChanges = new Array<RateChange>();
    this.originalRateChanges = new Array<RateChange>();
    this.charges = new RateCharges();
    this.rules = new Array<RateRule>();
    this.vatIsExcluded = false;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/reservation/rate/rate.model.ts